<template>
  <div class="p-0">
    <Alerts
      v-if="alertOptions.message"
      :alert-options="alertOptions"
    />

    <StripeCheckout
      v-if="booking.payment_provider==='stripe'"
      :return-url="returnUrl"
      :payment-preference-id="booking.payment_preference_id"
      :booking="booking"
      @paymentError="showAlertMessage()"
    />

    <PixPayment
      v-if="booking.payment_provider==='pix'"
      :return-url="returnUrl"
      :qr-code="booking.payment_qr_code"
      @paymentError="showAlertMessage()"
    />

    <MPCheckoutApi
      v-if="showMPAPIPayment"
      :booking="booking"
      :mp-link="mpButton"
      :mp-ios-link="mpAppIosButton"
      @paymentError="showAlertMessage()"
    />
  </div>
</template>
<script>
import Alerts from '@/components/Alerts/Alerts';
import StripeCheckout from './StripeCheckout';
import PixPayment from './PixPayment';
import MPCheckoutApi from './MPCheckoutApi';

export default {
  name: 'Payment',
  components: {
    MPCheckoutApi,
    PixPayment,
    StripeCheckout,
    Alerts,
  },

  props: {
    booking: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      alertOptions: {},
      returnUrl: {},
      mpAppIosButton: null,
      mpButton: null,
      showMPAPIPayment: false,
    };
  },
  created() {
    if (this.booking.payment_provider === 'stripe') {
      this.returnUrl = `${process.env.VUE_APP_URL}/process_payment/stripe?booking_id=${this.booking.id}`;
    }
    if (this.booking.payment_provider === 'pix') {
      this.returnUrl = `/process_payment/pix?booking_id=${this.booking.id}&payment_intent=${this.booking.payment_preference_id}`;
    }

    if (this.booking.payment_provider === 'mp') {
      this.showMPAPIPayment = true;

      if (!this.booking.payment_preference_id) {
        this.showAlertMessage();
      } else if (this.$store.state.main.app === 'ios') {
        this.mpAppIosButton = `https://www.mercadopago.com.ar/payment-link/v1/redirect?preference-id=${this.booking.payment_preference_id}`;
        this.mpAppIosButton = `${this.$router.currentRoute.path}?external-url=${this.mpAppIosButton}`;
      } else {
        this.mpButton = `https://www.mercadopago.com.ar/payment-link/v1/redirect?preference-id=${this.booking.payment_preference_id}`;
      }
    }
  },

  methods: {

    showAlertMessage() {
      this.alertOptions = {
        message: this.$t('lang.bookings.payment_preference_error'),
        variant: 'danger',
        delay: '10000',
      };
    },
  },

};
</script>
